import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HomeSlide from '../../../components/Home/Slides/HomeSlide';
import PeakDaySlide from '../../../components/Home/Slides/PeakDaySlide';
import './BackgroundDisplay.css';
import ToolSlide from '../Slides/ToolSlide';
import TutorDaySlide from '../Slides/TutorDaySlide';
import TaskSlide from '../Slides/TaskSlide';
import {directDeepLink, GET, makeApiCal, SOURCE_HOME} from '../../../util';
import LeaderboardSlide from "../Slides/LeaderboardSlide";
import PickHourlySlide from "../Slides/PickHourlySlide";
import {cosmosTrackService} from "../../../../../cosmosTracking/cosmosTrackService";
import {view_overview, view_year_end_review} from "../../../../../cosmosTracking/cosmosEvents";
import StarOfTheYearSlide from "../Slides/StarOfTheYearSlide";
import { resolveTutorHomeAsset, tutorHomeConfig, globalColors, globalBackgrounds, globalText } from '../tutorHomeConfig';
function BackgroundDisplay() {
	const sliderRef = useRef(null);
	const [background, setBackground] = useState(0);
	const [err, catchError] = useState(false);
	const [apiData, setApiData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const action = {
			method: GET,
			route: 'v1/campaign/homeCard',
			storeData: setApiData,
			catchError: catchError,
		};
		makeApiCal(action);
	}, []);

	useEffect(() => {
		if (apiData) {
			let userData = {
				...apiData.campaignOrg,
			};
			localStorage.setItem('saleData', JSON.stringify(userData));
			setIsLoading(false);
		}
		else if (err) {
			setIsLoading(false);
		}
	}, [apiData]);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 5000,
		appendDots: (dots) => <ul>{dots}</ul>,
		customPaging: (i) => (
			<div className="slick-indicator"></div>
		),
	};
	const slides = tutorHomeConfig.slides || {};
	const tutorHomeStyle = {
		'--tutor-page-background': `url("${resolveTutorHomeAsset(tutorHomeConfig.images?.page_background || 'https://cdn-wl-assets.classplus.co/production/379965/f659f314-c481-4f77-a065-598c1a2699a6.png')}")`,
		'--tutor-page-background-color': globalColors.accent_color || '#E35C22',
		'--tutor-progress-fill': globalColors.accent_color || '#E35C22',
		'--tutor-home-card-background': tutorHomeConfig.images?.card_background ? `url("${resolveTutorHomeAsset(tutorHomeConfig.images.card_background)}")` : undefined,
		'--tutor-primary-cta-background': globalColors.accent_color || '#E35C22',
		'--tutor-primary-cta-text': globalColors.button_text || '#fff',
		'--tutor-primary-text': globalColors.heading_color || '#232E4F',
		'--tutor-warm-text': globalColors.subheading || 'rgba(108, 39, 24, 1)',
		'--tutor-revenue-highlight': globalColors.accent_color || '#E35C22',
		'--tutor-milestone-title-gradient': globalBackgrounds.heading_text_gradient || 'linear-gradient(173.6deg, #FFFFFF 37.51%, #E1B677 94.96%)',
		'--tutor-milestone-card-border-gradient': globalBackgrounds.card_border_gradient || 'linear-gradient(180.22deg, #FFFFFF -6.79%, #E1B677 99.81%)',
		'--tutor-milestone-heading-text': globalColors.white_text || '#fff',
		'--tutor-milestone-left-gift': `url("${resolveTutorHomeAsset(slides.milestone?.images?.left_gift_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-milestone-gift-left-img.png')}")`,
		'--tutor-milestone-right-gift': `url("${resolveTutorHomeAsset(slides.milestone?.images?.right_gift_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-milestone-gift-right-img.png')}")`,
		'--tutor-pick-hour-revenue-highlight': globalColors.accent_color || '#E35C22',
		'--tutor-pick-hour-countdown-background': slides.pick_hourly?.colors?.countdown_background || 'linear-gradient(180deg, #FEE1CC 0%, #FFC4B1 100%)',
		'--tutor-pick-hour-countdown-text': globalColors.secondary_accent || 'rgba(218, 84, 97, 1)',
		'--tutor-pick-hour-countdown-value': globalColors.accent_color || '#E35C22',
		'--tutor-pick-hour-progress-fill': globalColors.accent_color || '#E35C22',
		'--tutor-pick-hour-prize-border': globalColors.accent_color || '#E35C22',
		'--tutor-tutor-day-card-background': globalColors.light_accent || '#FFD7B4',
		'--tutor-tutor-day-card-border': globalColors.accent_color || '#E35C22',
		'--tutor-tutor-day-organization-name': globalColors.heading_color || '#00008A',
		'--tutor-task-gift-card-border': globalColors.accent_color || '#E35C22',
	};
	return (
		<>
			<div className="homeDisplay" style={tutorHomeStyle}>
				<div className="homeDisplaySlider">
					<Slider {...settings} ref={sliderRef}>
						{apiData?.homeCard && (
							<HomeSlide data={apiData?.homeCard} campaignOrg={apiData?.campaignOrg} goalPrefix={globalText.goal_prefix} config={slides.home}/>
						)}
						{/*<StarOfTheYearSlide data={apiData?.homeCard}></StarOfTheYearSlide>*/}
						{apiData?.rankingsPage && (
							<LeaderboardSlide config={slides.leaderboard} data={
								apiData?.rankingsPage.teamRankings?.slice(0, 3)}
							  	deepLink={apiData?.homeCard?.deeplink}/>
						)}
						{(apiData?.peakDayCard || false )&& (
							<PeakDaySlide data={apiData?.peakDayCard} campaignOrg={apiData?.campaignOrg} config={slides.peak_day}/>
						)}
						{apiData?.peakHourCard &&(
							<PickHourlySlide hourData={apiData?.peakHourCard} config={slides.pick_hourly}/>
						)}
						{apiData?.tutorOfTheDayCard  && (
							<TutorDaySlide
								data={apiData?.tutorOfTheDayCard}
								rewardText={apiData?.awardsCard?.subText}
								config={slides.tutor_day}/>
						)}
						{apiData?.statCard  && <TaskSlide data={apiData?.statCard} config={slides.task}/>}
						{apiData?.toolsCard && <ToolSlide data={apiData?.toolsCard} config={slides.tool}/>}
					</Slider>
				</div>
				<div className="homeDisplayAction">
					<img className="SliderButton left" onClick={() => sliderRef.current.slickPrev()} src={resolveTutorHomeAsset(tutorHomeConfig.images?.carousel_previous_arrow || 'src/assets/images/left-arrow-26.svg')} width={32} alt="carouselLeft" />
					<img className="SliderButton right" onClick={() => sliderRef.current.slickNext()} src={resolveTutorHomeAsset(tutorHomeConfig.images?.carousel_next_arrow || 'src/assets/images/right-arrow-26.svg')} width={32} alt="carouselRight"/>
				</div>
			</div>
		</>
	);
}

export default BackgroundDisplay;
